import { FC } from 'react';
import { StackProps, VStack } from '@chakra-ui/react';

export const Wrapper: FC<StackProps> = ({ children, ...rest }) => (
  <VStack
    maxW={['full', 'full', '356px']}
    minW={['full', 'full', '356px']}
    spacing={6}
    {...rest}
  >
    {children}
  </VStack>
);
